import { Middleware } from "../middleware"


export default {
    getUsers(filter) {
        return new Middleware()
            .method('GET')
            .append(`/odin/mss_users`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size
            })
            .build()

    },
    getUsersIdProfile() {
        return new Middleware()
            .method('GET')
            .append(`/odin/mss_users/get`)
            .build()
    },


    getUserById(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/mss_users/${id}`)
            .build()


    },

    getProfiles() {
        return new Middleware()
            .method('GET')
            .append(`/odin/mss_users/profiles`)
            .build()

    },

    updateStatus(id) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/mss_users/${id}/switch_status`)
            .build()

    },

    saveUser(user) {
        return new Middleware()
            .method('POST')
            .append(`/odin/mss_users/`)
            .setData(user)
            .build()

    },

    updateUser(user) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/mss_users/${user.idMssUser}`)
            .setData(user)
            .build()
    },


    delete(id) {
        return new Middleware()
            .method('DELETE')
            .append(`/odin/mss_users/${id}`)
            .build()

    },

    resetPassword(id) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/mss_users/${id}/reset_password`)
            .build()

    }
}